exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#accordion .card[data-v-914f8eb4] {\n  margin-bottom: 0 !important;\n}\n.search-container[data-v-914f8eb4] {\n  position: relative;\n}\n.search-container i[data-v-914f8eb4] {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n.min-w-25[data-v-914f8eb4] {\n  min-width: 25%;\n}\n", ""]);

// exports
